module.exports = __webpack_public_path__ + "static/media/iphoneplus_splash.a7a9326f.png";